import React, { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import PropTypes from 'prop-types'
import { useNavigate } from '../../../hooks'

export default function TryDemoWelcomeOverlay({ overlay }) {
  const [t] = useTranslation()
  const [, setOpenedForLcrDemo] = useState(false)
  const { isTryDemo, location } = useNavigate()
  const isChooseYourDemo = location.pathname === '/choose-your-demo'
  const isLcrDemo = location.pathname.includes('lcr-demo')
  const heading = isLcrDemo
    ? t('tryDemo.lcr.overlay-title', 'Demo: Leader and Clerk Resources (LCR)')
    : t('tryDemo.fna.overlay-title', 'Demo: Family Name Assist')
  const message = isLcrDemo ? (
    <Trans
      i18nKey="tryDemo.lcr.overlay-message"
      components={{ strong: <strong /> }}
      defaults="Practice accessing and using <strong>Family Name Assist</strong> from Leader and Clerk Resources. This demo does not use actual data and information you enter will not be saved."
    />
  ) : (
    t(
      'tryDemo.fna.overlay-message',
      'Practice using Family Name Assist with this demo. This demo will not create or use actual data and will not look for matching names in FamilySearch. Information you enter will not be saved.'
    )
  )
  useEffect(() => {
    if (isTryDemo && !isChooseYourDemo) {
      setOpenedForLcrDemo((prevState) => {
        if (!prevState) {
          overlay.open()
        }
        return true
      })
    } else {
      overlay.close()
      setOpenedForLcrDemo(false)
    }
  }, [overlay, isLcrDemo, isChooseYourDemo, isTryDemo])

  return (
    <DialogOverlay {...overlay} title={heading} closeOnClickAway={false} data-testid="try-demo-welcome-overlay">
      <Paragraph size="sm">{message}</Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button data-testid="close-button" emphasis="medium" onClick={overlay.close}>
            {t('common-ui:close.action', 'Close')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}

TryDemoWelcomeOverlay.propTypes = {
  /** Standard overlay object returned from `useOverlay()` */
  overlay: PropTypes.shape({
    close: PropTypes.func,
    isOpen: PropTypes.bool,
    handleClick: PropTypes.func,
    transitioning: PropTypes.bool,
  }).isRequired,
  isTryDemo: PropTypes.bool,
}
